"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Icon = require("../../../components/media/icon/Icon");
var _globalTokens = require("../../../shared/global-tokens");
var NavigationMenuPrimitive = _interopRequireWildcard(require("@radix-ui/react-navigation-menu"));
var _Shared = require("./Shared.styled");
var _jsxRuntime = require("react/jsx-runtime");
var StyledSubmenuTrigger = (0, _styledComponents.default)(NavigationMenuPrimitive.Trigger).withConfig({
  displayName: "Submenu__StyledSubmenuTrigger",
  componentId: "sc-1qb6nwg-0"
})(["display:flex;align-items:center;justify-content:space-between;cursor:pointer;position:relative;", " width:100%;padding:", " ", " ", " ", ";border-radius:0 ", " ", " 0;border-style:solid;border-width:0 0 0 ", ";border-color:transparent;background:transparent;color:", ";&:hover{background:", ";}> a:hover{color:", ";}&:focus-visible{outline:none;}", " &[data-state='open']{color:", ";svg{transform:rotate(-180deg);path{fill:", ";}}}", ""], function (props) {
  return props.theme.sys.font.body['1'];
}, _globalTokens.globalSpacing['200'], _globalTokens.globalSpacing['400'], _globalTokens.globalSpacing['200'], _globalTokens.globalSpacing['400'], _globalTokens.globalBorder.radius['2'], _globalTokens.globalBorder.radius['2'], _globalTokens.globalSizing['100'], function (props) {
  return props.theme.sys.color.text.content.main;
}, function (props) {
  return props.theme.sys.color.background.primary['1'];
}, function (props) {
  return props.theme.sys.color.text.content.main;
}, function (props) {
  return props.$isActive ? "\n\t\t".concat(function (props) {
    return props.theme.sys.font.subheading['1'];
  }, "\n\t\tcolor: ").concat(function (props) {
    return props.theme.sys.color.text.content.primary;
  }, ";\n\t\tborder-color: ").concat(function (props) {
    return props.theme.sys.color.border.focusring;
  }, ";\n\t") : '';
}, function (props) {
  return props.theme.sys.color.text.content.primary;
}, function (props) {
  return props.theme.sys.color.text.content.primary;
}, function (props) {
  return props.level > 0 ? "border-color: ".concat(function (props) {
    return props.theme.sys.color.background.disabled['1'];
  }, ";") : '';
});
var Sub = function Sub(_ref) {
  var name = _ref.name,
    value = _ref.value,
    children = _ref.children,
    _ref$level = _ref.level,
    level = _ref$level === void 0 ? 0 : _ref$level,
    _ref$isActive = _ref.isActive,
    isActive = _ref$isActive === void 0 ? false : _ref$isActive,
    cy = _ref['data-cy'],
    props = _objectWithoutProperties(_ref, ["name", "value", "children", "level", "isActive", 'data-cy']);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Shared.StyledItem, _objectSpread({
    value: value
  }, props, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Shared.LevelContainer, {
      level: level,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledSubmenuTrigger, {
        level: level,
        $isActive: isActive,
        onPointerMove: function onPointerMove(event) {
          return event.preventDefault();
        },
        onPointerLeave: function onPointerLeave(event) {
          return event.preventDefault();
        },
        "data-cy": cy,
        children: [name, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          icon: 'chevronDown'
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(NavigationMenuPrimitive.Content, {
      onPointerLeave: function onPointerLeave(event) {
        return event.preventDefault();
      },
      onPointerDownOutside: function onPointerDownOutside(event) {
        return event.preventDefault();
      },
      onInteractOutside: function onInteractOutside(event) {
        return event.preventDefault();
      },
      onEscapeKeyDown: function onEscapeKeyDown(event) {
        return event.preventDefault();
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(NavigationMenuPrimitive.Sub, {
        orientation: "vertical",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Shared.StyledList, {
          children: _react.Children.map(children, function (child) {
            return /*#__PURE__*/_react.default.cloneElement(child, {
              level: level + 1
            });
          })
        })
      })
    })]
  }));
};
var _default = exports.default = Sub;